import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Sort } from '@angular/material/sort';

import { ExposureBySEGs, ExposureByTask } from 'src/app/models/exposureBySeg.model';
import { Task } from 'src/app/models/task.model';

@Component({
  standalone: false,
  selector: 'app-contribution-to-exposures',
  templateUrl: './contribution-to-exposures.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./contribution-to-exposures.component.scss']
})
export class ContributionToExposuresComponent implements OnInit {
  @Input() loading: boolean = true;
  @Input() exposureContribution: ExposureByTask[];
  @Input() showSegReport: boolean = true;
  @Input() selectedSEG: ExposureBySEGs;
  @Input() segTasks: Task[];
  show: boolean = false;
  taskExposureContributions: ExposureByTask[] = [];
  @Output() toggleTaskwithSEGPopupEmit = new EventEmitter<any>();
  @Output() sortExposureContributionEmit = new EventEmitter<any>();
  selectedTask: ExposureByTask;
  @Output() hideSEGDetailEmit = new EventEmitter<any>();
  @Output() showSEGDetailEmit = new EventEmitter<any>();
  @Input() showRep: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  toggleTaskwithSEGPopup(task: ExposureByTask) {
    this.toggleTaskwithSEGPopupEmit.emit(task);
  }

  sortExposureContribution(sort: Sort) {
    this.sortExposureContributionEmit.emit(sort);
  }

  getFilteredExposures(exposure: ExposureByTask) {
    return this.exposureContribution.filter(e => e.taskGroupId === exposure.taskGroupId)
  }

  onClick(selectedTask : ExposureByTask) {
    this.selectedTask = selectedTask;
    this.taskExposureContributions = this.exposureContribution.filter(e => e.taskGroupId === selectedTask.taskGroupId);
    this.show = true;
  }

  onClickReport(event: MouseEvent, selectedTask : ExposureByTask) {
    event.stopPropagation();
    this.selectedTask = selectedTask;
    this.taskExposureContributions = this.exposureContribution.filter(e => e.taskGroupId === selectedTask.taskGroupId);
    this.show = true;
  }

  hideTaskSupervisorFn() {
    setTimeout(() => {
      this.show = false;
      this.showRep = false;
      this.selectedTask = null;
    }, 100);
  }

  hideSEGDetailFn() {
    this.hideSEGDetailEmit.emit(false);
    this.showRep = false;
  }

  showSEGDetailFn() {
    this.showSEGDetailEmit.emit(true);
  }

  public trackByIndex = trackByIndex;
}
